<template>
  <v-app>
    <GlobalHeaderCheckout />
    <v-main>
      <slot />

      <ContentWrapper>
        <GlobalFooter />
      </ContentWrapper>
    </v-main>
  </v-app>
</template>
<script setup lang="ts">
useHead({
  titleTemplate: titleChunk => {
    return `${titleChunk}`
  },
})
</script>
